// CompactPreview.jsx
import { Box } from "@mui/material";
import Markdown from "./Markdown";

const CompactPreview = ({ children, lines = 8 }) => (
  <Box
    sx={{
      mb: 1.5,
      color: "text.secondary",
      fontSize: "0.875rem",
      lineHeight: 1.5,
      overflow: "hidden",
      overflowWrap: "anywhere",

      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: lines,

      // Fallback for browsers without line-clamp support.
      maxHeight: `calc(${lines} * 1.5em)`,

      "& h1, & h2, & h3, & h4, & h5, & h6": {
        fontSize: "0.875rem",
        fontWeight: 700,
        lineHeight: 1.4,
        mt: 0.75,
        mb: 0.25,
      },
      "& p": {
        my: 0.5,
      },
      "& ul, & ol": {
        my: 0.5,
        pl: 2.5,
      },
      "& li": {
        mb: 0.25,
      },
      "& > :first-of-type": {
        mt: 0,
      },
    }}
  >
    <Markdown>{children}</Markdown>
  </Box>
);

export default CompactPreview;